module.exports = __webpack_public_path__ + "img/lineup-3.f820ee10.jpg";